import { Link } from "react-router-dom";
import { Check, Gift, ShieldCheck } from "lucide-react";
import { formatGBP } from "@/lib/api";

const Row = ({ label, value, testid }) => (
  <div className="flex justify-between gap-4 py-3 text-sm">
    <dt className="text-[#A1A1AA]">{label}</dt>
    <dd className="text-right font-medium" data-testid={testid}>{value}</dd>
  </div>
);

export const OrderSummary = ({ plan, offer, chargePence }) => {
  if (!plan) return null;
  const first = plan.price_pence + chargePence;
  return (
    <aside className="rounded-3xl border border-[#D4A437]/30 bg-[#12100e] p-6 sm:p-8 lg:sticky lg:top-28" data-testid="order-summary">
      <p className="text-xs uppercase tracking-[0.2em] text-[#D4A437]">Your subscription</p>
      <div className="mt-3 flex items-end justify-between">
        <h2 className="font-display text-3xl font-bold" data-testid="summary-plan-name">{plan.name}</h2>
        <p className="font-display text-2xl font-bold" data-testid="summary-monthly-price">{formatGBP(plan.price_pence)}<span className="text-sm font-normal text-[#A1A1AA]">/mo</span></p>
      </div>
      <ul className="mt-5 space-y-2">
        {plan.contents.map((c) => <li key={c} className="flex gap-2 text-sm text-[#F7F5F0]/85"><Check className="h-4 w-4 shrink-0 text-[#FF6A00]" />{c}</li>)}
      </ul>
      {offer?.active && (
        <p className="mt-5 flex gap-2 rounded-xl bg-[#D4A437]/10 p-3 text-sm text-[#F3E0A2]" data-testid="summary-offer">
          <Gift className="h-4 w-4 shrink-0" /> {offer.name}: {offer.description} (subject to availability at payment)
        </p>
      )}
      <dl className="mt-6 divide-y divide-[#262626] border-y border-[#262626]">
        <Row label="Monthly price" value={formatGBP(plan.price_pence)} />
        <Row label="Delivery frequency" value="Monthly" />
        <Row label="Delivery" value={chargePence ? formatGBP(chargePence) : "Included"} />
        <Row label="First payment (today)" value={formatGBP(first)} testid="summary-first-payment" />
      </dl>
      <div className="mt-5 space-y-3 text-xs leading-relaxed text-[#A1A1AA]">
        <p><strong className="text-[#F7F5F0]/80">Renewal:</strong> renews automatically each month on the same date at {formatGBP(plan.price_pence)} until you pause or cancel.</p>
        <p><strong className="text-[#F7F5F0]/80">Cancellation:</strong> cancel online any time from My WeeLogRun. Cancellation takes effect at the end of your current paid month and any paid delivery will still be made. <Link to="/subscription-policy" className="text-[#FF6A00] underline">Full policy</Link></p>
        <p><strong className="text-[#F7F5F0]/80">Delivery day:</strong> we'll confirm your delivery day by email after you subscribe.</p>
      </div>
      <p className="mt-6 flex items-center gap-2 text-xs text-[#8a8a8a]"><ShieldCheck className="h-4 w-4 text-[#D4A437]" /> Card payments are taken on Stripe's secure payment page, which also handles your monthly payments. We never see or store your card details.</p>
    </aside>
  );
};
